import type { AccountManager as AccountManagerModel } from '@/adapters/catalogv1.g';

export function extractAccountManager(model: AccountManagerModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    accountRef: model.account_ref ?? '',
    managerAccountRef: model.manager_account_ref ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogAccountManager = ReturnType<typeof extractAccountManager>;
